import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const HecoAddresses = {
    TOKEN_RING: "0x15e65456310ecb216B51EfBd8a1dBf753353DcF9",
    TOKEN_KTON: "",
    TOKEN_WETH: "0x5545153CCFcA01fbd7Dd11C0b23ba694D9509A6F",
    ELEMENT_GOLD: "0xFB371c8B99ba0b239E66E0a66bB6296b00dCD09f",
    ELEMENT_WOOD: "0xcA3749C8C3aF04278D596a3fBe461481B6aa1b01",
    ELEMENT_WATER: "0x56746a8099a7e6D962802A23e01FeDdc1282cDAe",
    ELEMENT_FIRE: "0xe97C7F83ec91E29569f1a08De95ad3Bb0e8B6B3A",
    ELEMENT_SOIL: "0x81989cD57271565DBFfe9807E917Afc098B30c9A",
    GOLD_RUSH_RAFFLE: "0x6f75Dcd61579d9363799d282D6DD1f202295Ae84",
    PVETEAM_PROXY: "0x66B3f77Ba05e795A8Fd5ab60799d598312148e67",
    MATERIAL_PROXY: "0x24Fa741f4A8f2D5B460De2bDc5AE0041C87F3331",
    MATERIALTAKEBACK_PROXY: "0xA33a1308Ac1c7a7683C01a8036a1D722C441cD62",
    CRAFTBASE_PROXY: "0x150e06306583e0FD7EA3f2049bD72192380D13C9",
    LAND_CLOCK_AUCTION: "0xFdBEad883e975d92FbA03919a69b9A3A7EB9115B",
    APOSTLE_CLOCK_AUCTION: "0x4F1c93C5698cc0B2F506A449336CA44B0E111919",
    SIRING_CLOCK_AUCTION: "0xcC0dF56e56a4c01BCE8E2A3Ae5B8065C5eA53b2f",
    APOSTLE_BASE: "0xe8f06b4193cE6E32208Cf209e7B45b717FF3980a",
    LAND_RESOURCE: "0x34Ab84986f0a676A622a15eEdFBe8d344AE66A89",
    TOKEN_USE: "0x1B818FA80bBBaCD63a04c91a09dfeb7aA353b145",
    OBJECTOWNERSHIP: "0xf233bBD8F73fca654a84aEe1462F0c54b7fFE2bD",
    SETTINGSREGISTRY: "0x2401224012bAE7C2f217392665CA7abC16dCDE1e",
    POINTS_REWARD_POOL: "0xB74B584f9Eb39A14C5482D55bCf87A2165D09FcD",
    TOKEN_USER_POINTS: "0xdaE9d5E41119EacEba2a12B1bE5825e2D39DaC3d",
    FURNACE_TREASURE: "0xE4d2a04714Dd4F5ac0ce7DbBF03D4c944bbac486",
    FURNACE_ITEM_BASE: "0xc5f01D664B192FC7Fc0f2e166cf182FdaD315C0f",
    FURNACE_TAKEBACK: "0xd7b08EE01Ad1b6DB5a0d2f106CefB2E6b11c0082",
    UNISWAP_EXCHANGE: "0xED7d5F38C79115ca12fe6C0041abb22F0A06C300",
    STAKINGREWARDSFACTORY: "0x3158616c547afa169fb0057B67980630FD09F6dD",
    GOLDRAFFLEPOOL_PROXY: "0x3b08D68BF03D78257DF84bEcC3328C44E30F9352",
    WOODRAFFLEPOOL_PROXY: "0x1DebB82883440E961A5ed453100bF903e20A3ac6",
    WATERRAFFLEPOOL_PROXY: "0x408316B7A2dDc6a1e12f312A044252Bbb2366Be7",
    FIRERAFFLEPOOL_PROXY: "0xfAbBeE6404cd6C42492ae03bcEdf0FDc5dff0783",
    SOILRAFFLEPOOL_PROXY: "0x4E5b1975785761a2262B4665ce4406bb3996cc31",
};
export const HecoTokens = {
    RING: new Token(ChainId.HECO, HecoAddresses.TOKEN_RING, 18, "RING", "Darwinia Network Native Token"),
    GOLD: new Token(ChainId.HECO, HecoAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.HECO, HecoAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.HECO, HecoAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.HECO, HecoAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.HECO, HecoAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.HECO],
};
